// extracted by mini-css-extract-plugin
export default {"InfrastructureTests-section":"InfrastructureTests_InfrastructureTests-section__lsz9F"};